export default __webpack_public_path__ + "static/media/about_1.80f8e3c0.jpg";